<template>
  <div v-loading="loading">

      <div class="file-list">
        <div
            v-for="(file, index) of filesList"
            :key="index">

          <el-upload
              v-if="file.upload && editable"
              class="upload"
              :headers="fileHeaders()"
              name="upload"
              :action="upload.URL"
              :show-file-list="false"
              :on-success="sendFile"
              :on-error="errorSendFile"
              :before-upload="beforeSendFile">
            <img v-if="file.link" :src="getUrl(file)" class="avatar">
            <i v-else class="el-icon-plus file-list-icon"></i>
          </el-upload>

          <div v-if="file.link" class="files__preview">
            <el-avatar shape="square" :src="getUrl(file)"></el-avatar>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import Cookie from "js-cookie"

export default {
  name: "AttachedFiles",
  components: {},
  data() {
    return {
      loading: false,
      selectedComplex: 0,
      imageUrl: '',
      filesList: []
    }
  },
  computed: {
    upload() {
      return {
        URL: process.env.VUE_APP_ADMIN_API_BASE_URL + "/file/upload",
        data: {},
        headers: {
          Access: "application/json",
          "Accept-Language": "ru",
          "X-Requested-With": "XMLHttpRequest",
          "access-control-allow-origin": "*",
        },
      }
    }
  },
  props: {
    files: {},
    editable: {}
  },
  watch: {
    files() {
      this.generateFilesList()
    }
  },
  mounted() {
    this.generateFilesList()
  },
  methods: {
    getUrl(file) {
      return this.$root.getUrlPhoto(file.link.get)
    },
    fileHeaders() {
      return {
        Authorization: `Bearer ${this.trimCookie(
            Cookie.get("access_token")
        )}`
      }
    },
    trimCookie(cookie) {
      return cookie ? cookie.replace(/[А-Яа-я]/gi, "") : "";
    },
    generateFilesList() {
      this.filesList = []

      for (let i = 0; i <= 4; i++) {

        if (this.files[i]) {
          this.filesList.push(this.files[i])
        } else {
          this.filesList.push({
            upload: true
          })
        }
      }
    },

    sendFile(value) {

      this.loading = !!0
      if (!value) return

      this.$notify.success({
        title: "Файл был загружен",
        message: "Не забудьте сохранить изменения",
      })

      this.files.push(value)


    },
    errorSendFile() {
      this.loading = !!0
      this.$notify.error({
        title: "Ошибка отправки файла 😕",
        message: "Попробуйте открыть окно еще раз и повторите загрузку файла",
      })
    },
    beforeSendFile() {
      this.loading = !!1
    },
  }

}

</script>
<style lang="scss" scoped>
.files {
  margin-top: 12px;

  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #111;


  &__preview {
    margin: 5px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;

    width: 40px;
    height: 40px;

    img {

    }
  }

}

.file-list {
  display: flex;
  justify-content: flex-start;
  align-items: normal;

  margin: 5px -5px 0 -5px;

  .upload {

    margin: 5px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #2ac19f;
    }
  }
}


.file-list-icon {
  font-size: 18px;
  color: #32E6BE;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload {
  margin-top: 12px;

  .el-upload-dragger {
    width: auto;
    height: auto;
  }
}
</style>
